"use strict";
window._theme = window._theme || {};

_theme.initHeaderRewardEvents = function(){
  const loginBtn = document.querySelector('.rewards_dropdown_main .login');
  const loginBtnClose = document.querySelector('.rewards-popups div#rModal button.rClose');
  const signupBtn = document.querySelector('.rewards_dropdown_main .sign-up');
  const signupBtnClose = document.querySelector('.rewards-popups div#srModal button.srClose');

  if(loginBtn){
    loginBtn.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#rModal').classList.add('active');
    });
  }

  if(loginBtnClose){
    loginBtnClose.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#rModal').classList.remove('active');
    });
  }

  if(signupBtn){
    signupBtn.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#srModal').classList.add('active');
    });
  }

  if(signupBtnClose){
    signupBtnClose.addEventListener('click', function () {
      document.querySelector('.rewards-popups div#srModal').classList.remove('active');
    });
  }
}

$(document).ready(function(){
  _theme.initSlickSlider($('.bps-deals-list'), {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    accessibility: true,
    slidesToScroll: 1,
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 6000,
    responsive: [
        { breakpoint: 2400, settings: { slidesToShow: 4 }},
        { breakpoint: 1920, settings: { slidesToShow: 3.5 }},
        { breakpoint: 1700, settings: { slidesToShow: 3.5 }},
        { breakpoint: 1500, settings: { slidesToShow: 3.2 }},
        { breakpoint: 1300, settings: { slidesToShow: 2.8 }},
        { breakpoint: 998, settings: { slidesToShow: 1.8 }},
        { breakpoint: 768, settings: { slidesToShow: 1.5 }},
        { breakpoint: 600, settings: { slidesToShow: 2.2 }},
        { breakpoint: 500, settings: { slidesToShow: 1.5 }},
        { breakpoint: 320, settings: { slidesToShow: 1.2 }},
        { breakpoint: 1, settings: { slidesToShow: 1 }}
    ]
  });

  let showingContentAbove = false;
  let onlyDesktopSlider = false; 
  if($('.bf-deals-list').hasClass('showing-above-cont')){
    showingContentAbove = true;
  }
  if($('.bf-deals-list').hasClass('showing-only-desk-slider') && $(window).width() < 768){
    onlyDesktopSlider = true; 
    showingContentAbove = false;
  }
  if ($(window).width() > 768 || showingContentAbove) {
  _theme.initSlickSlider($('.bf-deals-list'), {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: showingContentAbove?4:4,
    accessibility: true,
    slidesToScroll: 1,
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 6000,
    responsive: [
        { breakpoint: 2400, settings: { slidesToShow: showingContentAbove?4:5 }},
        { breakpoint: 1920, settings: { slidesToShow: showingContentAbove?4:5 }},
        { breakpoint: 1700, settings: { slidesToShow: showingContentAbove?4:5 }},
        { breakpoint: 1500, settings: { slidesToShow: showingContentAbove?4:5 }},
        { breakpoint: 1300, settings: { slidesToShow: showingContentAbove?4:5 }},
        { breakpoint: 998, settings: { slidesToShow: showingContentAbove?3:4 }},
        { breakpoint: 768, settings: { slidesToShow: 3 }},
        { breakpoint: 600, settings: { slidesToShow: 1.5 }},
        { breakpoint: 320, settings: { slidesToShow: 1.5 }},
        { breakpoint: 1, settings: { slidesToShow: 1 }}
    ]
  });
  }

  _theme.initSlickSlider($('.img-text-card-wrapper'), {
    dots: false,
    arrows: true,
    infinite: false,
    slidesToShow: 4,
    accessibility: true,
    slidesToScroll: 1,
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
        { breakpoint: 2400, settings: { slidesToShow: 5.5 }},
        { breakpoint: 1921, settings: { slidesToShow: 4 }},
        { breakpoint: 1700, settings: { slidesToShow: 4.2 }},
        { breakpoint: 1500, settings: { slidesToShow: 3 }},
        { breakpoint: 1300, settings: { slidesToShow: 3 }},
        { breakpoint: 768, settings: { slidesToShow: 2.3 }},
        { breakpoint: 600, settings: { slidesToShow: 2 }},
        { breakpoint: 320, settings: { slidesToShow: 1.2 }},
        { breakpoint: 1, settings: { slidesToShow: 1.2 }}
    ]
});


const $parent = $('.img-text-card-wrapper').parent();
_theme.initSliderPlayPause($parent, $('.img-text-card-wrapper'), 'Carousel Slider');

if ($('.img-text-card-wrapper').hasClass('slick-initialized')) {
    $('.skeleton-wrapper').hide();
}

function restartAutoplay() {
    $('.img-text-card-wrapper').slick('slickSetOption', 'autoplay', true, true);
}

function jumpBackToFirst() {
    $('.img-text-card-wrapper').slick('slickPause');
    $('.img-text-card-wrapper').slick('slickGoTo', 0);
    setTimeout(restartAutoplay, 1000);
}

$('.img-text-card-wrapper').on('afterChange', function (event, slick, currentSlide) {
    const totalSlides = slick.$slides.length;
    const visibleSlides = slick.options.slidesToShow;

    if (currentSlide >= totalSlides - visibleSlides) {
        setTimeout(jumpBackToFirst, 3000);
    }
});



  if($('.card-vertical-slider .explore-card').length > 3){
    _theme.initSlickSlider($('.card-vertical-slider'),{
      rows:0,
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      accessibility: true,
      slidesToScroll: 1,
      mobileFirst:true,
      responsive: [
        { breakpoint: 1500, settings: { slidesToShow: 4}},
        { breakpoint: 1300, settings: { slidesToShow: 4,slidesToScroll: 1}},
        { breakpoint: 1090, settings: { slidesToShow: 3,slidesToScroll: 1}},
        { breakpoint: 840, settings: { slidesToShow: 2.8,slidesToScroll: 1}},
        { breakpoint: 767, settings: { slidesToShow: 2.5,slidesToScroll: 1}},
        { breakpoint: 600, settings: { slidesToShow: 2,slidesToScroll: 1,dots:true}}, 
        { breakpoint: 320, settings: { slidesToShow: 1.6, slidesToScroll: 1,dots:true}},
        { breakpoint: 1, settings: { slidesToShow: 1.2, slidesToScroll: 1,dots:true}}
    ]})
  }
      
  if($('.card-horizontal-slider .explore-card').length > 3){
    _theme.initSlickSlider(
      $('.card-horizontal-slider'),
      {
        rows:0,
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        accessibility: true,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
          { breakpoint: 1500, settings: { slidesToShow: 3}},
          { breakpoint: 1300, settings: { slidesToShow: 3,slidesToScroll: 1}},
          { breakpoint: 1090, settings: { slidesToShow: 3,slidesToScroll: 1}},
          { breakpoint: 840, settings: { slidesToShow: 2.8,slidesToScroll: 1}},
          { breakpoint: 767, settings: { slidesToShow: 2.5,slidesToScroll: 1}},
          { breakpoint: 600, settings: { slidesToShow: 2,slidesToScroll: 1,dots:false}}, 
          { breakpoint: 320, settings: { slidesToShow: 1.2, slidesToScroll: 1,dots:false}},
          { breakpoint: 1, settings: { slidesToShow: 1.2, slidesToScroll: 1,dots:false}}
      ]},
      null,
      (slick, currentSlide) => {
        const perPage = window.innerWidth < 768 ? 1 : 3;
        const colIndex = Math.ceil(currentSlide / perPage);
        _theme.track.trackView("Brands slider", colIndex);
      }
    )
  }

  var firstCategoryImagesCount = $('.category-div-images').first().find('.category-images').length;
  var firstCategoryDivWidth = $('.category-div-images').first().width();
  if(firstCategoryImagesCount <= 6){
    $('.category-div-images').css('width',firstCategoryDivWidth)
  }

  $('.category-div-images').each(function() {
      var $this = $(this);
      var categoryImagesCount = $this.find('.category-images').length;
      var isDesktop = $(window).width() > 1024;

      if ((isDesktop && categoryImagesCount > 6) || (!isDesktop && categoryImagesCount > 3)) {
          _theme.initSlickSlider($this, {
              dots: false,
              arrows: true,
              infinite: false,
              slidesToShow: categoryImagesCount <= 6? categoryImagesCount : 6,
              accessibility: true,
              slidesToScroll: 2,
              responsive: [
                  { breakpoint: 1500, settings: { slidesToShow: categoryImagesCount <= 6? categoryImagesCount : 6 } },
                  { breakpoint: 1400, settings: { slidesToShow: categoryImagesCount <= 6? categoryImagesCount : 4 } },
                  { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                  { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                  { breakpoint: 900, settings: { slidesToShow: 2.8, slidesToScroll: 1 } },
                  { breakpoint: 768, settings: { slidesToShow: 2.4, slidesToScroll: 1 } },
                  { breakpoint: 600, settings: { slidesToShow: 2.2, slidesToScroll: 1, dots: false } },
                  { breakpoint: 320, settings: { slidesToShow: 2.2, slidesToScroll: 1, dots: false } },
                  { breakpoint: 1, settings: { slidesToShow: 2.2, slidesToScroll: 1, dots: false } }
              ]
          });
      }
  });

  if(jQuery(window).width() < 1201 && $('.blog-article').length > 3){
    _theme.initSlickSlider($('.explore-blogs-wrapper'),{
      rows:0,
      dots: false,
      arrows: true,
      infinite: false,
      slidesToShow: 4,
      accessibility: true,
      slidesToScroll: 1,
      mobileFirst:true,
      responsive: [
        { breakpoint: 1500, settings: { slidesToShow: 3}},
        { breakpoint: 1300, settings: { slidesToShow: 3,slidesToScroll: 1}},
        { breakpoint: 768, settings: { slidesToShow: 4,slidesToScroll: 1}},
        { breakpoint: 600, settings: { slidesToShow: 3,slidesToScroll: 1,dots:false}}, 
        { breakpoint: 320, settings: { slidesToShow: 1.6, slidesToScroll: 1,dots:false}},
        { breakpoint: 1, settings: { slidesToShow: 1.6, slidesToScroll: 1,dots:false}}
      ]
    })
  }

  $('.category-div-images').each(function() {
      var $this = $(this);
      var categoryImagesCount = $this.find('.category-images').length;
      var isDesktop = $(window).width() > 1024;

      if ((isDesktop && categoryImagesCount > 6) || (!isDesktop && categoryImagesCount > 3)) {
          _theme.initSlickSlider($this, {
              dots: false,
              arrows: true,
              infinite: false,
              slidesToShow: categoryImagesCount <= 6? categoryImagesCount : 6,
              accessibility: true,
              slidesToScroll: 2,
              responsive: [
                  { breakpoint: 1500, settings: { slidesToShow: categoryImagesCount <= 6? categoryImagesCount : 6 } },
                  { breakpoint: 1400, settings: { slidesToShow: categoryImagesCount <= 6? categoryImagesCount : 4 } },
                  { breakpoint: 1201, settings: { slidesToShow: categoryImagesCount <= 6? categoryImagesCount : 4 } },
                  { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                  { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                  { breakpoint: 900, settings: { slidesToShow: 2.8, slidesToScroll: 1 } },
                  { breakpoint: 768, settings: { slidesToShow: 2.4, slidesToScroll: 1 } },
                  { breakpoint: 600, settings: { slidesToShow: 2.2, slidesToScroll: 1, dots: false } },
                  { breakpoint: 320, settings: { slidesToShow: 2.2, slidesToScroll: 1, dots: false } },
                  { breakpoint: 1, settings: { slidesToShow: 2.2, slidesToScroll: 1, dots: false } }
              ]
          });
      }
  });

  if(jQuery(window).width() < 1201){
    if($('.blog-article').length > 3){
      _theme.initSlickSlider($('.explore-blogs-wrapper'),{
        rows:0,
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        accessibility: true,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
          { breakpoint: 1500, settings: { slidesToShow: 3}},
          { breakpoint: 1300, settings: { slidesToShow: 3,slidesToScroll: 1}},
          { breakpoint: 768, settings: { slidesToShow: 4,slidesToScroll: 1}},
          { breakpoint: 600, settings: { slidesToShow: 3,slidesToScroll: 1,dots:false}}, 
          { breakpoint: 320, settings: { slidesToShow: 1.6, slidesToScroll: 1,dots:false}},
          { breakpoint: 1, settings: { slidesToShow: 1.6, slidesToScroll: 1,dots:false}}
        ]})
    }
  }
  const targetNode = document.querySelector('.be-ix-link-block');
  const observerR = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => { 
          if (mutation.type === 'childList') { 
              document.querySelector('.be-list')?.setAttribute('role','list');
              document.querySelectorAll('.be-list-item')?.forEach(el=>el?.setAttribute('role','listitem'));
          }
      }); 
  });
  observerR.observe(targetNode, { childList: true, subtree: true });
});

document.addEventListener("DOMContentLoaded", function (event) {
  _theme.initHeaderRewardEvents();
  
  const phoneInputs = document.querySelectorAll(
    'form input[name="customer[note][phone number]"]'
  );
  phoneInputs.forEach(function (input) {
    input.addEventListener("blur", function (evt) {
      if (!this.value) return;
      const phoneNum = Number(this.value.trim());
      if (!phoneNum) return;
      _theme.Helpers.setCookie("cphone", phoneNum, 7);
    });
  });

    /* account mobile sidebar */
    function MobileSidebar(){
      const button_account = document.querySelectorAll('#log-in-form .button-account');
      button_account.forEach(btn => {
        btn.addEventListener('click', () => {
          const tab = btn.getAttribute('tab');
          document.querySelectorAll('.account-box').forEach(box => box.classList.add('mobile-hide'));
          document.querySelector(`#${tab}`).classList.remove('mobile-hide');
          const btn_sign_reg = btn.closest('.btn-sign-reg') || btn.closest('.cm-bottom-in-up');
          if (btn_sign_reg) {
            document.querySelector('.back-btn').classList.remove('visibility-hidden');
          } else {
            document.querySelector('.back-btn').classList.add('visibility-hidden');
          }
        })
      })
  
      const account_btn = document.querySelector('.account-btn[customer="true"]');
      if(account_btn) {
        account_btn.addEventListener('click', (e) => {
          if (window.screen.width > 767) {
            e.preventDefault();
            window.location.href = '/account';
          }
        })
      }
    }
    MobileSidebar();
    /* end account mobile sidebar */
    /* category read more */
    function CategoryReadMore(){
    const categoryDesc = document.querySelectorAll('.category-desc-home');
    const categoryReadMore = document.querySelectorAll('.categ-read-more');
    console.log(categoryDesc, categoryReadMore);
    if(categoryDesc && categoryReadMore){
      categoryReadMore.forEach(readMore => {
      readMore.addEventListener('click', (e) => {
        e.preventDefault();
          e.target.parentElement.classList.toggle('show-more');
          e.target.parentElement.querySelector('.categ-read-more').textContent = e.target.parentElement.classList.contains('show-more') ? 'Read less' : 'Read more';
        })
      })
    }
    }
    setTimeout(() => {
      CategoryReadMore();
    }, 1000);
    /* end category read more */

});

/* header-lock */
const header = document.querySelector(".site-header .header-bottom");
const sticky = header.offsetTop;
window.onscroll = function() {
    if (window.scrollY > sticky) {
        header.classList.add("header-lock");
    } else {
        header.classList.remove("header-lock");
    }
};
/* end header-lock */

